import superAdminRoutes from "./routes/super-admin"
import adminRoutes from "./routes/admin"
import employeeRoutes from "./routes/employee"
import leadRoutes from "./routes/lead"
import commonRoutes from "./routes/common"
// Define your adminRoutes, employeeRoutes, and leadRoutes here...

function updateRoutesBasedOnUserRole(router, currentUser) {
  let routes;

   if (currentUser === 'super_admin') {
    routes = [];
    routes = [...superAdminRoutes, ...commonRoutes];
    }
     else if (currentUser === 'admin') {
        routes = [];
        routes = [...adminRoutes, ...commonRoutes];
     } 
    else if (currentUser === 'employee') {
        routes = [];
        routes = [...employeeRoutes, ...commonRoutes];
    }
   else if (currentUser === 'lead') {
    routes = [];
    routes = [...leadRoutes, ...commonRoutes];
  } 
     else {
        routes = [];
        routes = [...commonRoutes];
  }

  // Dynamically update the router's routes
//   router.getRoutes().forEach((route) => {
//     if (!routes.find((r) => r.path === route.path)) {
//       router.removeRoute(route.name);
//     }
//   });

  routes.forEach((route) => {
    // if (!router.hasRoute(route.name)) {
      router.addRoute(route);
    // }
  });
}

export { updateRoutesBasedOnUserRole };
